import * as yup from 'yup';
import { DataTableHtmlFormatter } from '../../../../../Component/Model/helpers';

export const projectedHeadcountSchema = (maxCommentLength: number) => yup.object().shape({
  comment: yup
    .string()
    .transform(value => DataTableHtmlFormatter(value, ''))
    .max(maxCommentLength, `Comment is too long! (Max length is ${maxCommentLength} characters)`)
    .nullable(), 

  selectedMethod: yup
    .string()
    .required('Please select a method'),

expectedNumberOfEmployeesYear1: yup
    .mixed()
    .when('selectedMethod', {
      is: (val: string) => val === '2', 
      then: yup
        .number()
        .typeError('Number of employees must be a number')
        .transform((value, originalValue) => {
          return originalValue === '' ? undefined : value;
        })
        .required('Number of Employees for Year 1 is required')
        .max(10000000, 'Number of Employees cannot be greater than 10,000,000'),
      otherwise: yup.mixed().nullable().notRequired(),
    }),

  expectedNumberOfEmployeesYear2: yup
      .mixed()
    .when('selectedMethod', {
      is: (val: string) => val === '2', 
      then: yup
        .number()
        .typeError('Number of employees must be a number')
        .transform((value, originalValue) => {
          return originalValue === '' ? undefined : value;
        })
        .required('Number of Employees for Year 2 is required')
        .max(10000000, 'Number of Employees cannot be greater than 10,000,000'),
      otherwise: yup.mixed().nullable().notRequired(),
    }),
  
  expectedNumberOfEmployeesYear3: yup
    .mixed()
    .when('selectedMethod', {
      is: (val: string) => val === '2', 
      then: yup
        .number()
        .typeError('Number of employees must be a number')
        .transform((value, originalValue) => {
          return originalValue === '' ? undefined : value;
        })
        .required('Number of Employees for Year 3 is required')
        .max(10000000, 'Number of Employees cannot be greater than 10,000,000'),
      otherwise: yup.mixed().nullable().notRequired(),
    }),

  expectedNumberOfEmployeesYear4: yup
    .mixed()
    .when('selectedMethod', {
      is: (val: string) => val === '2', 
      then: yup
        .number()
        .typeError('Number of employees must be a number')
        .transform((value, originalValue) => {
          return originalValue === '' ? undefined : value;
        })
        .required('Number of Employees for Year 4 is required')
        .max(10000000, 'Number of Employees cannot be greater than 10,000,000'),
      otherwise: yup.mixed().nullable().notRequired(),
    }),

  expectedNumberOfEmployeesYear5: yup
    .number()
    .typeError('Number of employees must be a number')
    .required('Number of Employees for Year 5 is required')
    .max(10000000, 'Number of Employees cannot be greater than 10,000,000'),

  expectedPercentageGrowthYear1: yup
    .mixed()
    .when('selectedMethod', {
      is: (val: string) => val === '2',
      then: yup
        .mixed()
        .test(
          'is-valid-number-or-na',
          'Growth must be a number',
          value => {
            if (value === '' || value === null || value === undefined) return false; 
            if (value === 'N/A') return true;
            return !isNaN(value) && !isNaN(parseFloat(value));
          }
        )
        .required('% Growth for Year 1 is required'),
      otherwise: yup.mixed().nullable().notRequired(),
    }),

  expectedPercentageGrowthYear2: yup
    .mixed()
    .when('selectedMethod', {
      is: (val: string) => val === '2',
      then: yup
        .mixed()
        .test(
          'is-valid-number-or-na',
          'Growth must be a number',
          value => {
            if (value === '' || value === null || value === undefined) return false; 
            if (value === 'N/A') return true;
            return !isNaN(value) && !isNaN(parseFloat(value));
          }
        )
        .required('% Growth for Year 2 is required'),
      otherwise: yup.mixed().nullable().notRequired(),
    }),

  expectedPercentageGrowthYear3: yup
    .mixed()
    .when('selectedMethod', {
      is: (val: string) => val === '2',
      then: yup
        .mixed()
        .test(
          'is-valid-number-or-na',
          'Growth must be a number',
          value => {
            if (value === '' || value === null || value === undefined) return false; 
            if (value === 'N/A') return true;
            return !isNaN(value) && !isNaN(parseFloat(value));
          }
        )
        .required('% Growth for Year 3 is required'),
      otherwise: yup.mixed().nullable().notRequired(),
    }),

  expectedPercentageGrowthYear4: yup
    .mixed()
    .when('selectedMethod', {
      is: (val: string) => val === '2',
      then: yup
        .mixed()
        .test(
          'is-valid-number-or-na',
          'Growth must be a number',
          value => {
            if (value === '' || value === null || value === undefined) return false; 
            if (value === 'N/A') return true;
            return !isNaN(value) && !isNaN(parseFloat(value));
          }
        )
        .required('% Growth for Year 4 is required'),
      otherwise: yup.mixed().nullable().notRequired(),
    }),

  expectedPercentageGrowthYear5: yup
    .mixed()
    .test(
      'is-valid-number-or-na',
      'Growth must be a number',
      value => {
        if (value === '' || value === null || value === undefined) return false; 
        if (value === 'N/A') return true;

        return !isNaN(value) && !isNaN(parseFloat(value));
      }
    )
    .required('% Growth for Year 5 is required'),
});